import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { EInterventionType } from 'src/app/domain/planning/enum/intervention-type';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { ChangeNavigationService } from 'src/app/tools/change-navigation-service';
import { CoreData } from 'src/app/tools/core-data';

@Component({
    selector: 'app-sub-menu',
    templateUrl: './sub-menu.component.html',
    styleUrl: './sub-menu.component.scss'
})
export class SubMenuComponent implements OnInit {
    // @Output() isExpanded: boolean;
    ENavigationRoute = ENavigationRoute;
    EInterventionType = EInterventionType;
    @Input() IsCollapseSubject: Subject<boolean>;

    get InterventionCode() {
        // console.log('intervention ' + this.coreData.CurrentIntervention.Code)
        return this.coreData.CurrentIntervention.Code;
    }

    get ProcessCode() {
        // console.log('process ' + this.coreData.CurrentIntervention.ProcessCode)
        return this.coreData.CurrentIntervention.ProcessCode;
    }

    get InterventionType() {
        // console.log('type ' + this.coreData.CurrentIntervention.Type)
        return this.coreData.CurrentIntervention.Type;
    }

    constructor(
        private ChangeNavigationService: ChangeNavigationService,
        private router: Router,
        private route: ActivatedRoute,
        public coreData: CoreData) {

    }
    ngOnInit(): void {

    }

    collapse() {
        this.IsCollapseSubject.next(false);
    }

    navigateTo(route: ENavigationRoute) {
        // if (route === ENavigationRoute.DescriptionStation)
        this.collapse()
        this.router.navigate([route, { type: this.InterventionType, interventionCode: this.InterventionCode, processCode: this.ProcessCode }])
        // this.ChangeNavigationService.hasNavigated();
    }

    navigateToPrestation() {
        this.collapse()
        this.router.navigate([this.getPrestationRoute(this.InterventionType), { type: this.InterventionType, interventionCode: this.InterventionCode, processCode: this.ProcessCode }])
        // this.ChangeNavigationService.hasNavigated();
    }

    getPrestationRoute(type: EInterventionType) {

        switch (type) {
            case EInterventionType.IBD:
                return ENavigationRoute.IBD;
            case EInterventionType.IBGN:
                return ENavigationRoute.IBGN;
            case EInterventionType.MPCE:
                return ENavigationRoute.MPCE;
            case EInterventionType.EAU:
                return ENavigationRoute.EAU;
            case EInterventionType.LAC:
                return ENavigationRoute.LAC;
            case EInterventionType.IBMR:
                return ENavigationRoute.IBMR;
            case EInterventionType.MGCE:
                return ENavigationRoute.MGCE;
            case EInterventionType.IML:
                return ENavigationRoute.IML;
        }
    }
}
